<template>
    <ThePage :class-name="'CatalogView'"
             :title="name?name:translate('CATALOG__CATALOG')">
        <template slot="left-action">
            <!--UP-->
            <BaseNavigationButton v-show="showUp"
                                  :icon="'icon-up'"
                                  @click="up()" />

            <!--BACK-->
            <BaseNavigationButton v-show="showBack"
                                  :icon="'icon-left'"
                                  @click="back()" />
        </template>
        <div class="CatalogView__body">
            <CatalogItem v-for="(item, index) in items" :key="item.id" :item="item"/>
        </div>
    </ThePage>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import ThePage from '../components/common/ThePage.vue';
    import BaseNavigationButton from '../components/common/BaseNavigationButton.vue';
    import CatalogItem from '../components/catalog/CatalogItem.vue';

    export default {
        name: 'CatalogView',
        components: {
            ThePage,
            BaseNavigationButton,
            CatalogItem
        },
        beforeRouteUpdate(to, from, next) {
            this.resolveParentGroup(+to.params.id);
            next();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.openGroup({
                    id: 0,
                    name: null
                });
            });
        },
        computed: {
            ...mapState({
                items: s => s.catalog.items,
                name: s => s.catalog.name
            }),
            ...mapGetters({
                showUp: 'catalog/showUp',
                showBack: 'catalog/showBack'
            })
        },
        methods: {
            ...mapActions({
                resolveParentGroup: 'catalog/resolveParentGroup',
                openGroup: 'catalog/openGroup',
                back: 'catalog/back',
                up: 'catalog/up'
            })
        }
    };
</script>

<style>
    .CatalogView {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .CatalogView__body {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
    }
</style>



// WEBPACK FOOTER //
// CatalogView.vue?279d7992